export default "__VITE_ASSET__nccvnMGB__"